import React from "react";
import ReactDOM from "react-dom/client";
import { analytics } from '@heycatch/sdk';
import "@/index.css";
import App from "@/App";
import './i18n'; // Initialize i18n

analytics.init({
  projectKey: 'hck_pk_rRgEWecDhsi3cz-nCZVL3ucCKVAlYl57',
  install: {
    framework: 'react',
    frameworkVersion: '19',
    agent: 'other',
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
